import React, { useEffect, useState } from 'react'
import { Dialog, Fade, Grid, IconButton, Typography } from '@mui/material'
import { useStyles } from './style'
import { ReButton } from '../..'
import PopperWrapper from '../popper-wrapper'
import { Close } from '@mui/icons-material'

export default function ResilienceToolkitModal ({ next, previous, cancelOnBoarding, isOnFeature }) {
  const classes = useStyles()
  const [ref, setRef] = useState(null)
  const [loaded, setLoaded] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      setRef(document.querySelector('.onboarding-resilience-toolkit'))
      setLoaded(true)
    }, 0)
  }, [])

  const Wrapper = ({ children }) => isOnFeature
    ? <Dialog open classes={{ paperWidthSm: classes.modal }} spacing={3}>{children}</Dialog>
    : <PopperWrapper element={ref} placement='right'>{children}</PopperWrapper>

  return (
    <Wrapper>
      <Fade in={loaded} timeout={400}>
        <Grid
          container
          justifyContent='center'
          direction='column'
          flexWrap='nowrap'
          className={classes.root}
        >
          <Grid style={{ position: 'absolute', top: 20, right: 20 }}>
            <IconButton onClick={cancelOnBoarding} color='primary'><Close style={{ fontSize: '30px' }} /></IconButton>
          </Grid>
          <Grid item xs={12}>
            <div style={{ height: '300px' }}>
              <img
                style={{ height: '100%' }}
                src='https://static.resilienceengine.live/img/toolkit-overview.svg'
                alt='Additional User Settings Congratulations'
              />
            </div>
            <Typography variant='h3' className={classes.title}>
                            Resilience Toolkit
            </Typography>
          </Grid>
          <Grid item xs={12} marginBottom={3}>
            <Typography marginBottom={2} component='p' variant='body3'>
                            The toolkit is available to you at any time, on demand, offering a library of resilience-boosting tools.
            </Typography>
            <Typography marginBottom={2} component='p' variant='body3'>
                            Follow your nose and see which tools catch your interest!
            </Typography>
            <Typography component='p' variant='body3'>
              If you aren't sure where to start, watch the Toolkit Overview video in Help to learn about Tool Pathways, which recommend tools specifically for you.
            </Typography>
          </Grid>
          <Grid item display='flex' justifyContent='flex-end' gap={5}>
            <ReButton fullWidth name='Previous' dataTestId='close_congratulations_modal' action={previous} />
            <ReButton fullWidth name='Next' dataTestId='close_congratulations_modal' action={next} />
          </Grid>
        </Grid>
      </Fade>
    </Wrapper>
  )
}
